module.exports = __webpack_public_path__ + "fonts/PingFangSC-Medium.a6794716.ttf";